export const isStagingEnv = process.env.REACT_APP_ENV === "staging";

export default {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL,
};
